import { Controller } from "@hotwired/stimulus"
// import CdvPurchase from "cordova-plugin-purchase/www/store.d"
import { Purchases, LOG_LEVEL, PURCHASES_ERROR_CODE } from '@revenuecat/purchases-capacitor';

// Connects to data-controller="payments"
export default class extends Controller {
  static values = {
    userUuid: String
  }

  connect() {
    document.addEventListener("deviceready", async function () {
      await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG }); // Enable to get debug logs
      await Purchases.configure({
        apiKey: "appl_dIbGETwMjQtXVmahtobYFiLULlm",
        appUserID: this.userUuidValue
      });
      this.offerings = await Purchases.getOfferings();
      this.drawSubs();
    }.bind(this), false);
  }

  drawSubs() {
    document.querySelector('#monthly_with_trial_price').innerHTML = this.offerings.all.sub_with_trial.monthly.product.pricePerMonthString
    document.querySelector('#annual_with_trial_price').innerHTML = this.offerings.all.sub_with_trial.annual.product.pricePerYearString
    document.querySelector('#monthly_no_trial_price').innerHTML = this.offerings.all.sub_no_trial.monthly.product.pricePerMonthString
    document.querySelector('#annual_no_trial_price').innerHTML = this.offerings.all.sub_no_trial.annual.product.pricePerYearString
  }

  async buy() {
    let aPackage = {};

    if (document.querySelector('input[type=checkbox]').checked) {
      if (document.querySelector('input[name=subscription_type_trial]:checked').value === 'annual') {
        aPackage = this.offerings.all.sub_with_trial.annual;
      } else {
        aPackage = this.offerings.all.sub_with_trial.monthly;
      }
    } else {
      if (document.querySelector('input[name=subscription_type]:checked').value === 'annual') {
        aPackage = this.offerings.all.sub_no_trial.annual;
      } else {
        aPackage = this.offerings.all.sub_no_trial.monthly;
      }
    }

    try {
      let purchaseResult = await Purchases.purchasePackage({ aPackage: aPackage });

      if (typeof purchaseResult.customerInfo.entitlements.active["Premium Subscription"] !== "undefined") {
        fetch('/paywall', {
          method: "POST",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(purchaseResult),
        }).then(async r => {
          let response = await r.json();

          if (response['success'] === true) {
            alert('Thanks! Your subscription was activated!');
            Turbo.visit('/stories');
          }
        })
      }
    } catch (error) {
      if (error.code === PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR) {
        alert('Purchase cancelled!')
      } else {
        alert('Error in payment process!')
      }
    }
  }

  toggleTrial() {
    document.querySelector('#no-trial').classList.toggle('hidden');
    document.querySelector('#trial').classList.toggle('hidden');
  }

  async restore() {
    let purchaseResult = await Purchases.getCustomerInfo();

    fetch('/paywall', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(purchaseResult),
    }).then(async r => {
      let response = await r.json();

      if (response['success'] === true) {
        alert('Subscriptions restored!');
        Turbo.visit('/stories');
      }
    })
  }
}
